import React, { forwardRef } from "react";
import classNames from "classnames";
import { StyledProps } from "../_type";
import { Tooltip } from "../tooltip";

export interface ListItemProps extends StyledProps {
  /**
   * 是否处于激活态
   */
  current?: boolean;

  /**
   * 是否处于选中态
   */
  selected?: boolean;

  /**
   * 是否处于禁用态
   */
  disabled?: boolean;

  /**
   * 点击时回调
   */
  onClick?: (evt: React.MouseEvent) => void;

  /**
   * Tooltip 说明文本
   */
  tooltip?: React.ReactNode;

  /**
   * 菜单项
   */
  children?: React.ReactNode;
}

const ListItemContext = React.createContext({
  isDisabled: false,
  isSelected: false,
  isCurrent: false,
});

export const useListItemContext = () => React.useContext(ListItemContext);

export const ListItem = forwardRef(function ListItem(
  {
    children,
    className,
    current,
    disabled,
    selected,
    onClick,
    tooltip,
    ...props
  }: ListItemProps,
  ref: React.Ref<HTMLLIElement>
) {
  let child = (
    <li
      {...props}
      ref={ref}
      className={classNames(className, {
        "is-current": current && !selected,
        "is-disabled": disabled,
        "is-selected": selected,
      })}
      onClick={disabled ? null : onClick}
    >
      {children}
    </li>
  );
  if (tooltip) {
    child = <Tooltip title={tooltip}>{child}</Tooltip>;
  }
  return child;
});

ListItem.displayName = "ListItem";
